import React, { Component } from "react";
import { Query } from "react-apollo";
import gql from "graphql-tag";
import Select from "react-select";
import { Label } from "office-ui-fabric-react/lib/Label";
import _ from "lodash";

class CountrySelect extends Component {
  render() {
    return (
      <Query query={GET_COUNTRIES}>
        {({ loading, err, data }) => {
          if (loading) return "Loading...";
          if (err) return `Error! ${err.message}`;

          const options = data.allCountries.nodes.map(country => ({
            label: country.nicename,
            value: country.id
          }));

          const {
            name,
            value,
            label,
            placeholder,
            touched,
            error
          } = this.props;

          return (
            <div>
              <Label>{label}</Label>
              <Select
                options={options}
                onChange={value => this.props.onChange(name, value)}
                onBlur={() => this.props.onBlur(name, true)}
                value={value}
                placeholder={placeholder}
                simpleValue
              />
              {!!error &&
                touched && <div className="error-message">{error}</div>}
            </div>
          );
        }}
      </Query>
    );
  }
}

const GET_COUNTRIES = gql`
  query allCountries {
    allCountries(orderBy: NAME_ASC) {
      nodes {
        id
        nicename
      }
    }
  }
`;

export default CountrySelect;



// WEBPACK FOOTER //
// ./src/common/Dropdowns/_CountrySelect.js